module.exports = __webpack_public_path__ + "static/ActaAgate-Bold-c40047050ec092929dc2ed361e8a1fb7.woff2";